module.exports = "/deep/ .ng-clear-wrapper {\n  line-height: 1em; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/forms/elements/components/select-2/select.component.scss
// module id = ./libs/chassis-core/src/app/forms/elements/components/select-2/select.component.scss
// module chunks = main